import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaSpinner } from 'react-icons/fa';
import { useEffect } from 'react';

export default function ProtectedRoute({ children, requiredRole = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Guardar la ruta actual en sessionStorage para recuperarla después del login
  useEffect(() => {
    if (!user && !loading) {
      sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    }
  }, [user, loading, location]);

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <FaSpinner className="spin" size={32} />
        <p className="mt-3">Verificando sesión...</p>
      </div>
    );
  }

  // Si no hay usuario autenticado, redirigir al login
  if (!user) {
    // Redirigir a login guardando la ubicación actual
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar si se requiere un rol específico
  if (requiredRole) {
    const userType = user.get('type') || 'client';
    const isAdmin = userType === 'admin' || user.get('isAdmin') === true;
    
    // Si se requiere rol de admin y el usuario no es admin
    if (requiredRole === 'admin' && !isAdmin) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
